import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Card,
  Select,
  DatePicker,
  Input,
  message,
} from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL , DateFormat,DateTimeFormat} from '../Components/Constant';
import Cookies from 'js-cookie';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const { Option } = Select;
const { TextArea } = Input;

const CallModal = ({
  visible,
  onClose,
  objectName,
  recordId,
  fetchActivityRecords,
  editingRecord,
}) => {
  const [form] = Form.useForm();
  const userId = Cookies.get('userId');
  const [users, setUsers] = useState([]);
  const currentDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (editingRecord) {
      form.setFieldsValue({
        Name: editingRecord.Name,
        Subject: editingRecord.Subject,
        Description: editingRecord.Description,
        Priority: editingRecord.Priority,
        Status: editingRecord.Status,
        AssignedTo: editingRecord.AssignedTo,
        StartDateTime: editingRecord.StartDateTime
          ? dayjs(editingRecord.StartDateTime, DateTimeFormat)
          : null, // Handle null values
        EndDateTime: editingRecord.EndDateTime
          ? dayjs(editingRecord.EndDateTime, DateTimeFormat)
          : null, // Handle null values
      });
    }
  }, [editingRecord]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/fetch_records/User`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();

      if (response?.records && Array.isArray(response?.records)) {
        const filteredUsers = response?.records?.filter((user) => user._id !== userId);
        setUsers(filteredUsers);
      }
  
    } catch (error) {
      console.error(error);
    }
  };

  const handleSave = async () => {
    try {
      const formValues = await form.validateFields(); // Retrieve validated form values

      // Set StartDateTime to current time if not provided
    if (!formValues.StartDateTime) {
      formValues.StartDateTime = dayjs();
    }

      if (formValues.StartDateTime) {
        // Or use custom formatting if needed:
        formValues.StartDateTime = dayjs(formValues.StartDateTime).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      
      if (formValues.EndDateTime) {
        // Or use custom formatting if needed:
        formValues.EndDateTime = dayjs(formValues.EndDateTime).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      const body = {
        object_name: "Activity",
        data: {
          ...formValues,
          ...(editingRecord?._id && { _id: editingRecord._id }),
        },
      };

      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { "Content-Type": "application/json" },
        "POST",
        body
      );

      const response = await apiService.makeCall();

      if (response && response.operation) {
        message.success("Call saved successfully!");
        onClose();
        form.resetFields();
        fetchActivityRecords();
      } else {
        message.error("Failed to save call. Please try again.");
      }
    } catch (error) {
      message.error("Validation failed or API error occurred.");
    }
  };

  return (
    <Modal
       title={
          <div style={{ fontSize: '20px', fontWeight: 'bold', padding: '20px 30px', borderBottom: '1px solid #e8e8e8' }}>
            
              {editingRecord ? "Edit Call" : "Create Call"}
            
            {/* <Button type="text" onClick={onClose} icon={<CloseOutlined />} /> */}
          </div>
        }
        width="40%"
        className="custom-modal"
        zIndex={1002}   // higher than sidebar
        visible={visible}
        onCancel={onClose}
        bodyStyle={{
          padding: 30,
          paddingBottom: 50,
          maxHeight: '67vh', //  Set max height to limit the body size
          overflowY: 'auto', //  Enable scrolling
        }}
        headerStyle={{
          padding: '20px 16px',
          background: '#f0f2f5',
          borderBottom: '1px solid #e8e8e8',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
        }}
        footer={
          <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 16px',
              background: '#f0f2f5',
              borderTop: '1px solid #e8e8e8',
              position: 'sticky',
              bottom: 0,
              zIndex: 1000,
            }}>
            <Button
              onClick={onClose}
              style={{
                height: "36px",
                width: "100px",
                fontSize: "14px",
                borderRadius: "8px",
                border: "1px solid #d9d9d9",
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSave}
              style={{
                height: "36px",
                width: "100px",
                fontSize: "14px",
                borderRadius: "8px",
              }}
            >
              Save
            </Button>
          </div>
        }
    >
      <Card
        style={{
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
            padding: "24px",
          }}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            AssociatedObject: objectName,
            ParentId: recordId,
            ActivityType: "Call",
            Status: "Completed",
            StartDateTime: editingRecord ? (editingRecord.StartDateTime ? dayjs(editingRecord.StartDateTime, "DD/MM/YYYY HH:mm A") : null) : dayjs(), // Default to current date & time
          }}
        >
            <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "20px",
          marginBottom: "24px",
        }}
      >
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "600",
            marginBottom: "16px",
            paddingBottom: "8px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          Call Details
        </h3>
          {/* Name */}
          <Form.Item
            label="Name"
            name="Name"
            style={{ display: "none" }}
            // rules={[{ required: true, message: "Please enter a name!" }]}
          >
            <Input placeholder="Enter name" />
          </Form.Item>

          {/* Activity Type */}
          <Form.Item
            label="Activity Type"
            name="ActivityType"
            style={{ display: "none" }}
            rules={[
              { required: true, message: "Please select an activity type!" },
            ]}
          >
            <Select placeholder="Select activity type" disabled>
              <Option value="Call">Call</Option>
              <Option value="Meeting">Meeting</Option>
              <Option value="Email">Email</Option>
              <Option value="Task">Task</Option>
              <Option value="Note">Note</Option>
            </Select>
          </Form.Item>

          {/* Subject */}
          <Form.Item label="Subject" name="Subject" rules={[{ required: true, message: "Please enter subject!" }]}>
            <Input placeholder="Enter subject" />
          </Form.Item>

          {/* Description */}
          <Form.Item label="Description" name="Description">
            <TextArea placeholder="Enter Description" rows={4} />
          </Form.Item>

          {/* Priority */}
          <Form.Item label="Priority" name="Priority">
            <Select placeholder="Select priority">
              <Option value="Low">Low</Option>
              <Option value="Medium">Medium</Option>
              <Option value="High">High</Option>
            </Select>
          </Form.Item>

          {/* Start Date & Time */}
          <Form.Item
            label="Start Date & Time"
            name="StartDateTime"
            style={{ display: "none" }}
          >
            <DatePicker
              showTime
              style={{ width: "100%" }}
              format="DD/MM/YYYY HH:mm A"
              value={
                form.getFieldValue("StartDateTime")
                  ? dayjs(form.getFieldValue("StartDateTime"))
                  : null
              }
              onChange={(date) => {
                form.setFieldValue("StartDateTime", date);
              }}
            />
          </Form.Item>

          {/* End Date & Time */}
          <Form.Item
            label="Call Date & Time"
            name="EndDateTime"
            initialValue={dayjs()}
            style={{ display: "none" }}
          >
            <DatePicker
              showTime
              style={{ width: "100%" }}
              format="DD/MM/YYYY HH:mm A"
              value={
                form.getFieldValue("EndDateTime")
                  ? dayjs(form.getFieldValue("EndDateTime"))
                  : null
              }
              onChange={(date) => {
                form.setFieldValue("EndDateTime", date);
              }}
            />
          </Form.Item>

          </div>
          <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "20px",
        }}
      >
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "600",
            marginBottom: "16px",
            paddingBottom: "8px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          Assignment
        </h3>

          {/* Assigned To */}
          <Form.Item label="Assigned To" name="AssignedTo">
          <Select
            showSearch
            placeholder="Select Assignee"
            optionFilterProp="label"
            allowClear
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={users.map(user => ({
              label: user.Name,
              value: user._id
            }))}
            value={selectedUser}  // Controlled value
            onChange={setSelectedUser}  // Handle change
          />
          </Form.Item> 

          </div>

          {/* Status */}
          <Form.Item label="Status" name="Status" style={{ display: "none" }}>
            <Select placeholder="Select status">
              <Option value="Pending">Pending</Option>
              <Option value="Completed">Completed</Option>
            </Select>
          </Form.Item>

          

          {/* Associated Object */}
          <Form.Item
            label="Associated Object"
            name="AssociatedObject"
            style={{ display: "none" }}
          >
            <Input placeholder="Enter associated object" disabled />
          </Form.Item>

          {/* Parent ID */}
          <Form.Item
            label="Parent ID"
            name="ParentId"
            style={{ display: "none" }}
          >
            <Input placeholder="Enter parent ID" disabled />
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  );
};

export default CallModal;
